
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rewriting/paraphrasing",
      function () {
        return require("private-next-pages/rewriting/paraphrasing.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rewriting/paraphrasing"])
      });
    }
  